import React from 'react';
import { TableInput } from '../..';
export var TableField = function TableField(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("h3", null, props.label), /*#__PURE__*/React.createElement(TableInput, {
    rowConfig: props.options,
    rows: props.value,
    onChange: props.onChange,
    onBlur: props.onBlur,
    onFocus: props.onFocus
  }));
};